/*
  gift-scarcity.js — contador único do lote do brinde, compartilhado pela
  faixa da página do produto (gift-claim-bar) e pelo card do carrinho
  (cart-gift-card). Uma configuração só, os dois sempre com o mesmo número.

  Lógica (settings do grupo "Brinde: escassez dinâmica"):
  - O lote começa numa data e hora do editor (AAAA-MM-DD HH:MM, fuso da
    loja) e dura N dias. Nesse intervalo o número desce em linha reta do
    valor inicial ao final: inicio - floor((inicio - fim) * progresso).
  - A conta sai do relógio, não de estado salvo por visitante: todas as
    clientes veem o mesmo número no mesmo momento, e quem volta dias
    depois vê a evolução. Nada fica preso no navegador.
  - Antes do início: valor inicial. Depois do fim: valor final, até um
    lote novo (trocar a data no editor). Data vazia ou fora do formato:
    valor inicial parado.
  - Teto: nunca acima do total nem do estoque real (data-gs-cap).
  - A MESMA conta existe no Liquid (snippets/gift-scarcity-value.liquid)
    para o HTML já chegar com o número certo. Este script corrige página
    em cache e atualiza a cada minuto com a página aberta. Mexeu numa
    conta, mexa na outra.

  Marcação esperada (renderizada pelos dois snippets):
  - raiz com [data-gift-scarcity] + a CONFIGURACAO em data-gs-*
  - [data-gift-remaining] restantes | [data-gift-claimed] resgatados
  - [data-gift-total] total       | [data-gift-fill] barra (width %)

  Os dois namespaces sao separados de proposito: com a configuracao em
  data-gift-* a raiz casava com [data-gift-total], tinha o textContent
  trocado e o card inteiro sumia, sobrando so o numero.

  O card do carrinho e re-renderizado pelo cart.js a cada mudanca de
  carrinho; um MutationObserver repinta o numero assim que a marcacao
  nova entra no DOM.
*/

(function () {
  'use strict';

  if (window.__giftScarcity) return;
  window.__giftScarcity = true;

  var ROOT = '[data-gift-scarcity]';
  var MINUTO = 60000;
  var DIA = 24 * 60 * MINUTO;
  var cfg = null;
  var pendente = null;

  function toInt(valor, padrao) {
    var n = parseInt(valor, 10);
    return isNaN(n) ? padrao : n;
  }

  /* "AAAA-MM-DD HH:MM" no fuso da loja (data-gs-offset, ex. "-0300")
     -> milissegundos UTC; null se vazio ou fora do formato */
  function inicioDoLote(texto, fuso) {
    var d = /^(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2})$/.exec(String(texto || '').trim());
    var z = /^([+-])(\d{2}):?(\d{2})$/.exec(String(fuso || '').trim());
    if (!d || !z) return null;
    if (+d[2] < 1 || +d[2] > 12 || +d[3] < 1 || +d[3] > 31 || +d[4] > 23 || +d[5] > 59) return null;
    var minutos = (z[1] === '-' ? -1 : 1) * (+z[2] * 60 + +z[3]);
    return Date.UTC(+d[1], +d[2] - 1, +d[3], +d[4], +d[5]) - minutos * MINUTO;
  }

  function lerConfig() {
    var root = document.querySelector(ROOT);
    if (!root) return null;

    /* CONFIGURACAO vem em data-gs-*; os ganchos de EXIBICAO sao
       data-gift-*. Namespaces separados de proposito: a raiz nao pode
       casar com os seletores que este script reescreve. */
    var d = root.dataset;
    var total = Math.max(1, toInt(d.gsTotal, 100));
    var cap = Math.max(0, toInt(d.gsCap, 0));
    var inicio = Math.max(1, toInt(d.gsStart, 12));

    return {
      total: total,
      teto: cap > 0 ? Math.min(total, cap) : total,
      inicio: inicio,
      /* o fim nunca acima do inicio: o numero so desce */
      fim: Math.max(1, Math.min(toInt(d.gsEnd, 4), inicio)),
      comeco: inicioDoLote(d.gsBatch, d.gsOffset),
      duracao: Math.max(1, toInt(d.gsDays, 7)) * DIA
    };
  }

  function restantes(c, agora) {
    var valor = c.inicio;
    if (c.comeco !== null) {
      var progresso = Math.min(1, Math.max(0, (agora - c.comeco) / c.duracao));
      valor = c.inicio - Math.floor((c.inicio - c.fim) * progresso);
    }
    return Math.max(1, Math.min(valor, c.teto));
  }

  function pulsar(el) {
    el.classList.remove('is-gift-bump');
    void el.offsetWidth;
    el.classList.add('is-gift-bump');
  }

  /* Escreve apenas quando o valor mudou — e o que impede o
     MutationObserver de se realimentar em laco. O :not() e uma trava:
     a raiz do componente jamais pode ter o textContent trocado, senao
     apaga o card inteiro. */
  function texto(seletor, valor, mudados) {
    var alvo = String(valor);
    document.querySelectorAll(seletor + ':not([data-gift-scarcity])').forEach(function (el) {
      if (el.textContent === alvo) return;
      el.textContent = alvo;
      mudados.push(el);
    });
  }

  function pintar(animar) {
    if (!cfg) return;
    var restam = restantes(cfg, Date.now());
    var resgatados = Math.max(0, cfg.total - restam);
    var pct = Math.round((restam * 100) / cfg.total);
    var mudados = [];

    texto('[data-gift-remaining]', restam, mudados);
    texto('[data-gift-claimed]', resgatados, mudados);
    texto('[data-gift-total]', cfg.total, mudados);

    document.querySelectorAll('[data-gift-fill]').forEach(function (el) {
      el.style.width = pct + '%';
    });

    if (animar) mudados.forEach(pulsar);
  }

  function iniciar() {
    cfg = lerConfig();
    pintar(false);
  }

  function observar() {
    if (!window.MutationObserver || !document.body) return;
    new MutationObserver(function () {
      clearTimeout(pendente);
      pendente = setTimeout(function () {
        /* o card do carrinho pode aparecer depois da primeira carga */
        if (!cfg) iniciar();
        else pintar(false);
      }, 80);
    }).observe(document.body, { childList: true, subtree: true });
  }

  function bootstrap() {
    iniciar();
    observar();
    /* com a pagina aberta, o numero acompanha o lote; pulsa so quando muda */
    setInterval(function () {
      if (!cfg) iniciar();
      else pintar(true);
    }, MINUTO);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();
